export default "__VITE_ASSET__uRlB9oXM__"